module.exports = __webpack_public_path__ + "static/media/tshare_ftm_lp.9dca2209.png";